import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

export const BaseField = styled(TextField)`
  & .MuiFilledInput-root {
    border-radius: 5px;
  }
  & .MuiFilledInput-underline:before {
    content: unset;
  }
  & .MuiFilledInput-underline:after {
    content: unset;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(p) => p.theme.sellerTheme.primary.safeColorAgainstBg};
  }

  & .MuiInputBase-input {
    &::placeholder {
      font-size: 1.5rem;
      vertical-align: middle;
    }
  }
`;
